import {
  LuBook,
  LuGlobe,
  LuLink,
  LuMusic,
  LuNewspaper,
  LuUsers,
  LuUserPen,
  LuClapperboard,
  LuStickyNote,
  LuPodcast,
  LuPalette,
} from "react-icons/lu";

export const categoryItems = [
  { label: "All", value: "All", icon: LuGlobe },
  { label: "Book", value: "Book", icon: LuBook },
  { label: "Author", value: "Author", icon: LuUserPen },
  { label: "Artist", value: "Artist", icon: LuPalette },
  { label: "Article", value: "Article", icon: LuStickyNote },
  { label: "Podcast", value: "Podcast", icon: LuPodcast },
  { label: "Music", value: "Music", icon: LuMusic },
  { label: "Video", value: "Video", icon: LuClapperboard },
  { label: "Social", value: "Social", icon: LuUsers },
  { label: "Newsletter", value: "Newsletter", icon: LuNewspaper },
  { label: "Generic", value: "Generic", icon: LuLink },
];

/**
 * A simple array of valid category strings, excluding "All" for validation purposes.
 */
export const validCategories = categoryItems
  .map((item) => item.value)
  .filter((value) => value !== "All");
